import * as React from 'react';
import DashboardNumbersContainer from '~/containers/Dashboard/DashboardNumbers';

import { t } from '~/i18n';
import { Panel } from '@ixicare/ui';
import DashboardAlertListContainer from '~/containers/Dashboard/DashboardAlertList';
import AlertStatusContainer from '~/containers/Alerts/AlertStatus';
import DashboardAlertActivityContainer from '~/containers/Dashboard/AlertActity';
import UserNotifications from '~containers/UI/UserNotifications';
import DashboardView from '~components/DashboardView';
import { useStores } from '~store/utils';
import { observer } from 'mobx-react';

const DashboardPage = observer(() => {
  const { sites, alerts, graphs } = useStores();
  const selectedSite = sites.selectedSite;
  const title = t('menu.dashboard.dashboard') + ' · ' + (selectedSite?.name ?? '');

  React.useEffect(() => {
    if (title) {
      document.title = t('meta.title', { title });
    }
  }, [title]);

  // Refetch alerts + stats whenever the selected site changes. AlertsStore
  // swaps to the per-site bucket; AlertActivity refetches into that bucket.
  React.useEffect(() => {
    if (!selectedSite) return;
    alerts.fetchAlerts(selectedSite.uuid);
    graphs.global.loadStats(selectedSite.uuid);
    graphs.alertActivity.loadData();
  }, [selectedSite, alerts, graphs.global, graphs.alertActivity]);

  return (
    <>
      <DashboardView title={title}>
        <UserNotifications>
          <div className="mb-30">
            <DashboardNumbersContainer />
          </div>
          <div className="row">
            <div className="col-md-8 mb-30">
              <Panel>
                <Panel.Title>{t('dashboard.panels.alertActivity')}</Panel.Title>
                <DashboardAlertActivityContainer />
              </Panel>
            </div>
            <div className="col-md-4 mb-30">
              <Panel>
                <AlertStatusContainer />
              </Panel>
            </div>
          </div>
          <Panel>
            <Panel.Title>{t('dashboard.panels.recentAlerts')}</Panel.Title>
            <DashboardAlertListContainer />
          </Panel>
        </UserNotifications>
      </DashboardView>
    </>
  );
});

export default DashboardPage;
